import {expertiseStatusExcelCell} from "./Cell/ExpertiseStatus";
import {skillExcelCell} from "./Cell/Skill";
import {specialityExcelCell} from "./Cell/Speciality";
import {programExcelCell} from "./Cell/Program";
import {localDateExcelCell} from "./Cell/LocalDate";
import {nameListExcelCell} from "./Cell/NameList";
import {phoneExcelCell} from "./Cell/Phone";
import {groupStateExcelCell} from "./Cell/GroupState";
import {planStateExcelCell} from "./Cell/PlanState";
import {personExcelCell} from "./Cell/PersonName";
import {contactsExcelCell} from "./Cell/Contacts";
import {groupPlanExcelCell} from "./Cell/GroupPlan";
import {requestStateExcelCell} from "./Cell/RequestProgramStatus";
import {masterClassStateExcelCell} from "./Cell/MasterClassStatus";
import {coordinatesExcelCell} from "./Cell/Coordinates";

function dispatchExcelCellContent(options, column, gridCell) {
  if (column.qType === "ExpertiseStatus") {
    expertiseStatusExcelCell(options, column, gridCell);
  } else if (column.qType === "Skill") {
    skillExcelCell(options, column, gridCell);
  } else if (column.qType === "Speciality") {
    specialityExcelCell(options, column, gridCell);
  } else if (column.qType === "Program" || column.qType === "ProgramGrouping") {
    programExcelCell(options, column, gridCell);
  }  else if (column.qType === "LocalDate") {
    localDateExcelCell(options, column, gridCell);
  } else if (column.qType === "NameList") {
    nameListExcelCell(options, column, gridCell);
  } else if (column.qType === "Phone") {
    phoneExcelCell(options, column, gridCell);
  } else if (column.qType === "GroupState") {
    groupStateExcelCell(options, column, gridCell);
  } else if (column.qType === "PlanState") {
    planStateExcelCell(options, column, gridCell);
  } else if (column.qType === "Person") {
    personExcelCell(options, column, gridCell);
  } else if (column.qType === "Contacts") {
    contactsExcelCell(options, column, gridCell);
  } else if (column.qType === "ProgramPlanCheck") {
    groupPlanExcelCell(options, column, gridCell);
  } else if (column.qType === "RequestProgramStatus") {
    requestStateExcelCell(options, column, gridCell);
  } else if (column.qType === "MasterClassState") {
    masterClassStateExcelCell(options, column, gridCell);
  } else if (column.qType === "Coordinates") {
    coordinatesExcelCell(options, column, gridCell);
  }
}

export default function (options) {
  let gridCell = options.gridCell;
  if (gridCell.rowType === 'data') {
    dispatchExcelCellContent(options, gridCell.column, gridCell);
  } else if (gridCell.rowType === 'header') {

  }
}
